<template>
  <router-view />
</template>

<style></style>
<script  setup lang='ts'>

</script>
